import React from 'react'
import type { OverlayProps } from 'react-bootstrap'
import { useTableContext } from '../Context'
import { BasePopover } from '../BasePopover'
import { CloseButton, HorizontalStack } from '@ztechapps/webui.util'
import { ResetConfigButton } from './ResetConfigButton'
import { ColumnList } from './ColumnList'
import { ResetFilter } from './ResetFilter'

const Header = () => {
  const { setShowConfig } = useTableContext()

  return (
    <HorizontalStack className="justify-content-between">
      <div>Table Config</div>
      <HorizontalStack gap={1}>
        <ResetFilter /> |
        <ResetConfigButton />
        <CloseButton onClick={() => setShowConfig(false)} />
      </HorizontalStack>
    </HorizontalStack>
  )
}

export const PopoverTableConfig = ({ target }: { target: OverlayProps['target'] }) => {
  const { name, showConfig, setShowConfig } = useTableContext()

  return (
    <BasePopover
      name={`${name}-table-config`}
      show={showConfig}
      setShow={setShowConfig}
      target={target}
      header={<Header />}
    >
      <ColumnList />
    </BasePopover>
  )
}
